/**
 * Deriva un nombre legible a partir de la parte local del correo del
 * administrador (lo que precede a `@`).
 *
 * Es una aproximación deliberada: la sesión de Supabase solo expone el
 * correo (`session.user.email`), no hay una columna de nombre en
 * `admins`. Mostrar un nombre real (p. ej. "Héctor Durán") requeriría
 * añadir esa columna a la tabla `admins` -y poblarla-; hasta entonces,
 * este es el mejor nombre "de pantalla" que se puede construir sin
 * inventar datos.
 *
 * hduranc@siesa.com.pa    -> "Hduranc"
 * vsarmiento@siesa.com.pa -> "Vsarmiento"
 */
export default function deriveDisplayName(email) {
  if (!email) return '';

  const [localPart] = email.split('@');
  if (!localPart) return '';

  return localPart.charAt(0).toUpperCase() + localPart.slice(1).toLowerCase();
}
